import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus, getHostName } from '../redux/FeedbackRedux';


class ClickedLink extends React.Component {


	



	render () {
		var hostName = getHostName(this.props.link.url);
		if(hostName == "google.com")
		{
			hostName = "Google";
		}

		if(hostName == "facebook.com")
		{
			hostName = "Facebook";
		}

		if(hostName == "yelp.com")
		{
			hostName = "Yelp";
		}

		
		return ( 
			<div className="col-md-12 ">
				<span className="text-primary"><a href={this.props.link.url} target="_blank">{hostName}</a></span>
				<p className="text-muted">{this.props.link.created_at}</p>
			</div> 
			);
	}
}

export default ClickedLink;
// function mapStateToProps(state) {
// 	return { state:state }
// }

// export default connect(mapStateToProps)(FeedbackList)